import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useOrganizations () {
  return useQuery('organizations', async () => {
    const organizations = await axios.get(`${getApiServer()}/organizations`)
    return organizations.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}